import BaseService from './base.service'

class StationService extends BaseService {
    getAvailablePosts(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Station.getAvailablePosts',
                    params: {
                        stationId: params?.stationId,
                        date: params?.date, // unix (выбранный день)
                        carId: params?.carId,
                        carModelId: params?.carModelId,
                        repairIds: params?.repairIds,
                    },
                })
                .then(response => resolve(response.data))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }

    getFreeTime(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Station.getFreeTime',
                    params: {
                        stationId: params?.stationId,
                        date: params?.date, // unix (выбранный день)
                    },
                })
                .then(response => resolve(response.data))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }

    getList() {
        return new Promise((resolve, reject) => {
            return this.request({ public: true }).post({
                method: 'Station.getList',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }
}

export default new StationService()
